module.exports = __webpack_public_path__ + "media/images/a_five-62f0dbbadff5c2ca5a3c0f602d065666.png";